import * as Yup from "yup";

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const jobRegistrationSchema = Yup.object().shape({
    name: Yup.string().required("Please enter your name."),
    mobile: Yup.string().matches(phoneRegExp, "Please enter a valid mobile number.").required("Please enter your mobile number.")
  });